<template>
  <div class="mb-4">
    <div class="ml-3 mb-2">
      <span class="hyp-section-title application-heading" :style="styleTitle">{{
        titleModified
      }}</span>
    </div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "LeftSidePanelSection",
  props: {
    title: {
      type: String,
      required: true,
    },
    isMini: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    titleModified() {
      return this.isMini ? "&nbsp;" : this.title;
    },
    styleTitle() {
      const visible = this.isMini ? "hidden" : "visible";
      return {
        visibility: visible,
      };
    },
  },
};
</script>

<style scoped lang="scss">
.hyp-section-title {
  font-size: 15px;
  text-decoration: underline;
  text-transform: uppercase;
  color: #3d4957;
}
</style>
